export class TelegramService {
    constructor(backButtonHandler){
        this.tg = window.Telegram?.WebApp;
        this.initData = null;
        this.user = null;
        this.isTelegram = false;
        this.backButton = null;
        this.init(backButtonHandler);
    }

    init(backButtonHandler){
        if (this.tg){
            this.isTelegram = true;
            this.tg.ready();
            this.tg.expand();

            this.initData = this.tg.initData;
            this.user = this.tg.initDataUnsafe?.user;

            this.tg.onEvent('backButtonClicked', () => {
                backButtonHandler();
            })
        }
    }

    // initBackButton(backButtonHandler) {
    //     // this.backButton = this.tg.BackButton;
    //     this.tg.onEvent('backButtonClicked', () => {
    //         backButtonHandler();
    //     })
    //     // this.backButton.onClick(() => {
    //     //     backButtonHandler();
    //     // });
    // }

    getUser() {
        return this.user;
    }
    
    getInitData() {
        return this.initData;
    }
    
    isInTelegram() {
        return this.isTelegram;
    }

    close() {
        if (this.tg?.close) {
            this.tg.close();
        }
    }

    sendData(data) {
        if (this.tg?.sendData) {
            this.tg.sendData(JSON.stringify(data));
        } else {
            console.log('Data to send:', data);
        }
    }
}